export class PagedCollectionParams {
  private offset = 0;
  private limit: number;
  private sortExpression: string;
  private sortDirection: 'asc' | 'desc' | '';
  private query: string;
  private productId: number | null = null;

  constructor(params: {
    offset: number;
    limit: number;
    sortExpression?: string;
    sortDirection?: 'asc' | 'desc' | '';
    query?: string;
    productId?: number;
  }) {
    this.offset = params.offset;
    this.limit = params.limit;
    this.sortExpression = params.sortExpression ? params.sortExpression : '';
    this.sortDirection = params.sortDirection ? params.sortDirection : '';
    this.query = params.query ? params.query : '';
    this.productId = params.productId ? params.productId : null;
  }

  get urlParams() {
    const params = new URLSearchParams();

    params.append('offset', String(this.offset));
    params.append('limit', String(this.limit));

    if (this.sortDirection && this.sortExpression) {
      params.append('sortExpression', this.sortExpression);
      params.append('sortDirection', this.sortDirection);
    }

    if (this.query) {
      params.append('query', this.query);
    }

    if (typeof this.productId === 'number' && this.productId > 0) {
      params.append('productId', String(this.productId));
    }

    return params.toString();
  }
}
